var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container justify-content-center"},[_c('div',{staticClass:"copyright text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }